import React from "react";
import { Card, Divider, Typography } from "antd";
import GetBin from "../../../components/Wash/ViewBin/GetBin";
import "../../../styles/global-ui.css";

const ViewBinPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            View Bin
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan or enter a bin ID to view bin details
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <GetBin userData={userData} />
      </Card>
    </div>
  );
};

export default ViewBinPage;